/*eslint-disable*/
import React, { useEffect, useState } from 'react'
import Axios from 'axios';
import APP_CONSTANTS from '../../../config/constants';
import { Table, Form as FormUi, Header } from 'semantic-ui-react'
import { Field } from 'formik'
import { MyNormalInput } from '../../apiInputComponent/myInput'
import ReactDatePicker from 'react-datepicker'
import SerialNumber from '../../apiInputComponent/serialNumber'
import moment from 'moment'
import TyreSerialNumber from '../../apiInputComponent/tyreSerialNumber'
import VehicleAttachedSerialNumber from './vehicleSerialNumber';

const VehicleAddTyreTable = (props) => {
  const [postions, setpostions] = useState([])
  useEffect(() => {
    getAllTyre()
  }, [props.id])

  let handleDate = (index, date) => {
    let infoVal = [...postions]
    infoVal[index]["installationDate"] = date
    setpostions(infoVal)
  }

  let handlePosition = (e, data) => {
    if (data.name === 'kms') {
      let val = data.value
      let idx = data.dataid
      let infoVal = [...postions]
      // infoVal[idx].tyrData = val
      infoVal[idx]['tyreRun'] = val
      setpostions(infoVal)
    }
  }


  const setTyreData = (index, data) => {
    let val = data.value
    let idx = index
    let infoVal = [...postions]
    infoVal[idx]["serialNo"] = data.serialNo
    infoVal[idx]["productInventoryId"] = data.productInventoryId
    setpostions(infoVal)
  }

  const getAllTyre = () => {
    let token = localStorage.getItem('apiToken')
    let userId = localStorage.getItem('userId')
    let customerNo = localStorage.getItem('customerNo')

    Axios.get(`${APP_CONSTANTS.BASE_URL}masters/vehicleTypeTyrePositionMapping/?customerNumber=${customerNo}&userId=${userId}&vehicleTypeId=${props.id}`, {
      headers: {
        'Content-Type': 'application/json',
        "Authorization": token,
        "Access-Control-Allow-Origin": "*"
      }
    })
      .then((response => {
        let allTyreSet = response.data.resultSet
        setpostions(allTyreSet)
        setIsLoading(false)

      }))
      .catch(error => console.log(error))
  }


  props.tyrData(postions)
  return (
    <>
      <Table size="small">
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell colSpan="4" ><Header color="blue" size="tiny" className="labelName p-bold-500">Tyre Details</Header></Table.HeaderCell>
          </Table.Row>
          <Table.Row>
            <Table.HeaderCell className="labelName p-bold-500">Tyre Position</Table.HeaderCell>
            <Table.HeaderCell className="labelName p-bold-500">Serial No.</Table.HeaderCell>
            <Table.HeaderCell className="labelName p-bold-500">Tyre Run(Kms)</Table.HeaderCell>
            <Table.HeaderCell className="labelName p-bold-500">Installation Date</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {postions.map((object, index) => (
            <Table.Row key={index + 1}>
              <Table.Cell>
                {object.tyrePosition}
              </Table.Cell>
              <Table.Cell className='display-flex'>
                <Field autoComplete="off" component={VehicleAttachedSerialNumber} setTyreData={setTyreData} TyreId="1"  name="srNo" dataValue="srNo" dataMainId={object.positionId} /* onChange={setTyreData} */ dataid={index} id={`tyreserialNumber${index}`} />
              </Table.Cell>
              <Table.Cell>
                <Field autoComplete="off" type="number" component={MyNormalInput} onChange={handlePosition} dataid={index} name="kms" />
              </Table.Cell>
              <Table.Cell>
                <ReactDatePicker
                  autoComplete="off"
                  name='installationDate'
                  selected={postions?.[index]?.installationDate ? postions[index].installationDate : ''}
                  onChange={date => {
                    handleDate(index, date)
                    let infoVal = [...postions]
                    infoVal[index]['installationDate'] = date
                    setpostions(infoVal)
                  }}
                  dateFormat="dd/MM/yyyy"
                  customInput={<FormUi.Input icon="time" style={{ width: '210px' }} iconPosition="left" />}
                />
              </Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
    </>
  )
}

export default VehicleAddTyreTable